import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { http, formatApiError } from "../lib/api";

const inp = "w-full border border-slate-300 rounded-md px-3 py-2 text-sm mt-1";

export const XaltixSenderCard = () => {
  const [s, setS] = useState(null);
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => { http.get("/xaltix/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const save = async () => {
    setBusy(true);
    try {
      const r = await http.put("/xaltix/settings", { contact_email: s.contact_email, smtp_password: pwd || undefined });
      setS(r.data); setPwd(""); setErr("");
      toast.success(pwd ? "Connexion à la boîte vérifiée : mot de passe enregistré" : "Adresse d'envoi enregistrée");
    } catch (e) { const m = formatApiError(e); setErr(m); toast.error(m); } finally { setBusy(false); }
  };
  return (
    <section className="bg-white border border-slate-200 rounded-md p-6" data-testid="xaltix-sender-card">
      <h2 className="font-display font-bold text-xl mb-1 flex items-center gap-2"><Mail className="h-5 w-5" />Boîte d'envoi des e-mails XALTIX</h2>
      <p className="text-xs text-slate-500 mb-4">Tous les e-mails envoyés par XALTIX aux entreprises clientes (devis, factures, avoirs, relances, reçus, codes de signature, notifications) partent de cette adresse via {s.smtp_host}.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <label className="block"><span className="text-[11px] font-bold uppercase tracking-wider text-slate-500">Adresse d'envoi</span>
          <input type="email" className={inp} value={s.contact_email || ""} onChange={(e) => setS({ ...s, contact_email: e.target.value })} placeholder="contact@solutions-prime.fr" data-testid="xaltix-sender-email-input" /></label>
        <label className="block"><span className="text-[11px] font-bold uppercase tracking-wider text-slate-500">Mot de passe de la boîte {s.smtp_password_set ? <span className="text-emerald-600 normal-case" data-testid="xaltix-sender-pwd-set">· enregistré</span> : <span className="text-rose-600 normal-case" data-testid="xaltix-sender-pwd-missing">· non renseigné</span>}</span>
          <input type="password" className={inp} value={pwd} onChange={(e) => { setPwd(e.target.value); setErr(""); }} autoComplete="new-password" placeholder={s.smtp_password_set ? "•••••••• (laisser vide pour conserver)" : "Mot de passe Hostinger"} data-testid="xaltix-sender-password-input" />
          {err && <span className="block mt-1 text-[11px] font-semibold text-rose-600" data-testid="xaltix-sender-error">{err}</span>}</label>
      </div>
      <div className="flex items-center gap-3 mt-4">
        <button onClick={save} disabled={busy} className="px-4 py-2 rounded-md bg-slate-900 text-white text-sm font-semibold disabled:opacity-60" data-testid="xaltix-sender-save-btn">{busy ? "Vérification…" : "Vérifier et enregistrer"}</button>
        <span className="text-[11px] text-slate-500">La connexion est testée auprès du serveur avant l'enregistrement.</span>
      </div>
    </section>
  );
};
